/* eslint-disable */
(function() {
  var $ = require('jquery');
  var Cookies = require('js-cookie');

  var $target = $('.cookie-panel');

  var $close = $('.cookie-close', $target);

  $close.click(function(e) {
    e.preventDefault();

    Cookies.set('cookie-policy', true, {
      expires: 360,
      path: '/',
    });

    $target.hide();
  });

  var cookie = Cookies.get('cookie-policy');

  if (cookie === undefined) {
    $target.show();
  }
})();
